<template>
    <el-upload
        v-on="$listeners"
        v-bind="$attrs"
        :accept="acceptValue"
        :show-file-list="false"
        :data="qiniu.data"
        :action="qiniu.qiniuUploadUrl"
        :before-upload="beforeAvatarUpload"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :on-progress="uploadProgress"
    >
        <template v-if="useDefault">
            <div  class="upload-wrapper">
                <div  class="upload-inner  has-no-pic"  v-if="!hasPic">
                    <img  :src="defaultUploadImg"  alt  />
                    <span  class="tips">{{defaultTips}}</span>
                </div>
                <div  class="upload-inner  has-pic"  v-else>
                    <!-- <img  :src="imgSrc  ||  ''"  alt  @click.stop="enlargeImg"  /> -->
                    <!-- <div class="bg-img" :style="{ background: `url(${imgSrc || ''}) center / cover no-repeat` }"
                        @click.stop="enlargeImg"/> -->
                    <el-image
                        :style="`width: ${defaultWidth}px; height: ${defaultHeight}px`"
                        fit="cover"
                        :src="imgSrc || ''"
                        :preview-src-list="[imgSrc || '']"
                        @click.native.stop>
                    </el-image>
                    <i
                        class="el-icon  el-icon-close  not-click-upload"
                        v-if="!isUpload"
                        @click.stop="$emit('clear-img')"
                    />
                    <span  class="tips"  v-if="!isUpload">点击更换照片</span>
                </div>
                <div  class="progress  not-click-upload"  v-if="isUpload"  @click.stop>
                    <span  class="percent">{{  uploadPercent  }}</span>
                    <div  class="progress-bar">
                        <div  class="inner"  :style="`transform:  translate3d(${offsetUploadPercent},  0,  0)`"  />
                    </div>
                </div>
                <div  class="mask  not-click-upload"  v-if="isUpload"  @click.stop  />
            </div>
        </template>
        <slot v-else/>
        <video ref="video" style="display: none" @canplaythrough="videoCanPlayThrough($event.target)" @error="videoError" />
    </el-upload>
</template>

<script>
import $fetch from "@/api"
import { openMessage } from '@/utils/system.tsx'
import { getQiniuImgUrl } from '@/assets/ts/qiniu'

export default {
    data() {
        return {
            isUpload: false,
            uploadPercent: "0%",
            videoDuration: null,
            qiniu: {
                qiniuUploadUrl: "https://up.qiniup.com",
                qiniuImageURLPrefix: "https://img.senguo.cc/",
                qiniuVideoURLPrefix: "https://v.senguo.cc/",
                data: {
                    key: "",
                    token: ""
                }
            }
        }
    },
    props: {
        imgSrc: {
            type: String,
            default: ''
        },
        imgLimit: {
            type: Number,
            default: 800
        },
        useDefault: {
            type: Boolean,
            default: true
        },
        defaultUploadImg:{
            default: require('./images/upload-bg.svg'),
        },
        defaultTips: {
            type: String,
            default: '上传照片'
        },
        defaultWidth: {
            type: Number,
            default: 94
        },
        defaultHeight: {
            type: Number,
            default: 94
        },
        beforeUpload: {
            type: Function,
            default() {
                return true
            }
        },
        isVideo: {
            type: Boolean,
            default: false
        },
        accept: {
            type: String,
            default: 'image/jpeg,  image/gif,  image/png,  image/bmp'
        },
        onUploadSuccess: Function,  // 出于异常原因（可能打包的时候自定义事件没了），发生自定义事件无法触发的情况，所以用props可以补救一下
        onUploadError: Function,
        onUploadProcess: Function,
        fileNameSuffix: {
            type: String,
            default: 'not set'
        } // 上传的文件名称后缀
    },
    computed: {
        hasPic() {
            return this.imgSrc !== ''
        },

        offsetUploadPercent() {
            return window.parseInt(this.uploadPercent, 10) - 100 + "%"
        },

        acceptValue() {
            return this.isVideo ? 'video/*' : this.accept
        }
    },
    methods: {
        videoError(e) {
            console.log('===', e)
            this.videReject && this.videReject('支持文件扩展名为.mp4、.mov、.m4v的视频文件')
        },

        videoCanPlayThrough(video) {
            if (!video) {
                this.videReject && this.videReject('预期之外的错误')
            }
            const duration = video.duration
            if (duration > 120) {
                this.videReject && this.videReject('单个视频限制2分钟以内')
            } else {
                this.videoDuration = Math.ceil(duration)
                this.videoResolve && this.videoResolve()
            }
        },

        getQiniuToken(bucket = 1) {
            return $fetch.post({
                    url: "/goods/getqiniutoken",
                    params: {
                        bucket
                    }
                }).then(data => {
                    this.qiniu.data.token = data.token
                }).catch(e => {
                    openMessage("error", e.message || "网络错误")
                })
        },

        uploadSuccess(response, file, fileList) {
            openMessage("success", "上传成功")
            this.isUpload && (this.isUpload = false)
            const rawFile = this.getRawFile(file)
            const isVideoFile = this.isVideoFile(rawFile)
            const imgSource = getQiniuImgUrl(response.key, this.imgLimit)
            const uploadResult = {
                imgSrc: imgSource,
                key: response.key,
                uid: file.uid,
                name: rawFile.name || file.name,
                size: Math.ceil((rawFile.size || file.size || 0) / 1024),
                duration: isVideoFile ? this.videoDuration : null
            }
            this.$emit('upload-success', {
                ...uploadResult
            })
            this.onUploadSuccess && this.onUploadSuccess(uploadResult)
            this.videoDuration = null
        },

        uploadError() {
            openMessage("error", "上传失败")
            this.isUpload && (this.isUpload = false)
            this.$emit('upload-error')
            this.onUploadError && this.onUploadError()
        },

        uploadProgress(e) {
            const uploadPercent = window.parseInt(e.percent, 10) + "%"
            this.uploadPercent = uploadPercent
            this.$emit('upload-progress', uploadPercent)
            this.onUploadProcess && this.onUploadProcess(uploadPercent)
        },

        judgeVideoIsReady() {
            return new Promise((resolve, reject) => {
                this.videoResolve = resolve
                this.videReject = reject
            })
        },

        getRawFile(file) {
            return file.raw || file
        },

        isVideoFile(file) {
            const type = file.type || ''
            const name = file.name || ''
            return type.includes('video') || /\.(mp4|mov|m4v)$/i.test(name)
        },

        getFileSuffix(file) {
            const type = file.type || ''
            const name = file.name || ''
            const nameSuffix = (name.match(/\.([^.]+)$/) || [])[1]
            const mimeSuffix = (type.split('/')[1] || '').replace('jpeg', 'jpg')
            return nameSuffix || mimeSuffix || 'jpg'
        },

        async beforeUploadStart(file) {
            const [type, name] = file.type.split("/")
            const isVideoFile = this.isVideoFile(file)
            await this.getQiniuToken(isVideoFile ? 2 : 1)
            const isLt2M = file.size / 1024 / 1024 < 20
            // const isLt100M = file.size / 1024 / 1024 < 100
            // if (!isLt100M && type.includes('video')) {
            //     openMessage("error", "上传视频大小不能超过 100MB!")
            //     return Promise.reject()
            // }
            console.log('type', type)
            console.log('name', name)
            if (!isLt2M && type.includes('image')) {
                openMessage("error", "上传头像图片大小不能超过 2MB!")
                return Promise.reject()
            }
            if (isVideoFile && !/\.(mp4|mov|m4v)$/i.test(file.name) && !['mp4', 'quicktime', 'x-m4v', 'm4v'].includes(name)) {
                openMessage('error', '支持文件扩展名为.mp4、.mov、.m4v的视频文件')
                return Promise.reject()
            }
            try {
                if (isVideoFile) {
                    const url = URL.createObjectURL(file)
                    this.$refs.video.src = url
                    await this.judgeVideoIsReady()
                }
            } catch (e) {
                openMessage('error', e)
                return Promise.reject()
            }
            this.qiniu.data.key = `new_ls/${Date.now()}.${this.fileNameSuffix !== 'not set' ? this.fileNameSuffix : this.getFileSuffix(file)}`
            !this.isUpload && (this.isUpload = true)
        },

        async beforeAvatarUpload(file) {
            const beforeResult = this.beforeUpload(file)
            if (typeof beforeResult === 'boolean') {
                return beforeResult ? await this.beforeUploadStart(file) : Promise.reject()
            } else {
                await beforeResult  // 为Promise或返回值不为boolean
                await this.beforeUploadStart(file)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.upload-wrapper {
    position: relative;
    vertical-align: text-top;
    color: #fff;

    .upload-wrapper {
        position: relative;
        vertical-align: text-top;
        color: #fff;
    }

    .progress {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        z-index: 2;
        cursor: default;

        .percent {
            display: inline-block;
            margin-bottom: 4px;
        }

        &-bar {
            width: 90px;
            height: 4px;
            background: #fff;
            border-radius: 4px;
            overflow: hidden;

            .inner {
                height: 100%;
                border-radius: 4px;
                background: #009688;
                transform: translate3d(-100%, 0, 0);
            }
        }
    }

    .mask {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        cursor: default;
    }

    .upload-inner {
        font-size: 12px;

        > div {
            border: 1px solid #ddd;
        }

        .bg-img {
            width: 100%;
            height: 100%;
        }

        &.has-no-pic {
            color: #333;

            .tips {
                position: absolute;
                left: 50%;
                width: 96px;
                transform: translate3d(-50%, 62px, 0);
            }
        }

        &.has-pic {
            font-weight: normal;

            .el-icon-close {
                position: absolute;
                right: 3px;
                top: 3px;
                width: 16px;
                height: 16px;
                line-height: 16px;
                text-align: center;
                border-radius: 50%;
                background: rgba(51, 51, 51, 0.7);
            }

            .not-click-upload {
                cursor: default;
            }

            .tips {
                position: absolute;
                left: 0;
                bottom: 2px;
                width: 100%;
                height: 20px;
                line-height: 20px;
                text-align: center;
                background: rgba(0, 0, 0, 0.5);
            }
        }
    }
}
</style>
